import Styles from "./subHeader.module.css";

export function SubHeader({ children }) {
  return (
    <nav className={Styles.sub_header}>
      {children.map((item) => {
        return (
          <>
            {item}
            <hr className="content_end_mark" />
          </>
        );
      })}
    </nav>
  );
}
